import http from "@/services/http";

export const categories = () => {
  async function list() {
    const {data} = await http.get('/categories/list');
    return data;
  }

  async function store(categoria) {
    const response = await http.post('/categories/store', categoria);
    return response.data;
  }

  async function delet(id) {
    await http.put('/categories/delete/'+id,{});
    return true;
  }

  async function update(categoria) {
    const response = await http.post('/categories/edit',categoria);
    return response.data;
  }

  async function getOne(id) {
    const {data} = await http.get('/categories/getOne/'+id);
    return data;
  }

  async function getByLink(link) {
    const {data} = await http.get('/categories/getOne/'+link);
    return data;
  }

  return {list, store, delet, update,getOne,getByLink};
}